import { createAsyncThunk } from "@reduxjs/toolkit";
import { editUser as editUserApi } from "../../apiCalls/caller";
import { toast } from "react-toastify";

export const editUsers = createAsyncThunk("users/editUser", async (user) => {
  toast.dismiss();
  try {
    const response = editUserApi(user);
    const data = await response;
    toast.dismiss();
    if (data.success) {
      toast.success("Updated Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
    } else {
      toast.error("Updating Failed " + data.message, {
        position: "top-center",
        autoClose: 3000,
      });
    }
    return response;
  } catch (error) {
    toast.error("Updating Failed " + error, {
      position: "top-center",
      autoClose: 3000,
    });
    return error;
  }
});
